import ProductComboProductSelection from "./ProductComboGroupSelection.js";
import * as CommonUtilities from "../../../../common/utils/CommonUtils.js";

export default function ProductComboGroup(props) {
    
    let elementToReturn;
    if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
        // Bulk Pricing
        elementToReturn = <>
            <div className="col-sm-6 pb-3">
                <div className=" ">                
                    <b>{props.productComboGroupDetails.productComboGroupName}</b>
                </div>
                <ProductComboProductSelection
                    key={props.productComboGroupDetails.productComboGroupID}
                    productComboGroupDetails={props.productComboGroupDetails}
                    groupFormData={props.groupFormData}
                    groupValidationData={props.groupValidationData}
                    handleProductComboGroupSelect={props.handleProductComboGroupSelect}
                    addToCartError={props.addToCartError}
                    />
            </div>
        </>

    } else {
        elementToReturn = <>
            <div className="col-12">
                <hr className="text-body-tertiary"/>
            </div>
            <div className="col-12 pb-2">                
                <b>{props.productComboGroupDetails.productComboGroupName}</b>
            </div>
            <ProductComboProductSelection
                key={props.productComboGroupDetails.productComboGroupID}
                productComboGroupDetails={props.productComboGroupDetails}
                groupFormData={props.groupFormData}
                groupValidationData={props.groupValidationData}
                handleProductComboGroupSelect={props.handleProductComboGroupSelect}
                addToCartError={props.addToCartError}
            />
        </>
    }

    return (
        <>
            {elementToReturn}
        </>
    )
}